export const RatingType = {
  EXCELLENT: 'EXCELLENT',
  GOOD: 'GOOD',
  MEDIOCRE: 'MEDIOCRE',
  POOR: 'POOR',
};

export const ratingTypes = [
  RatingType.EXCELLENT,
  RatingType.GOOD,
  RatingType.MEDIOCRE,
  RatingType.POOR,
];
